// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
      wm-ugc-synchronized-badge {
        ion-icon {
          width: 22px;
          height: 22px;
          border-radius: 8px;
          padding: 3px;
          background-color: #fff;
          &[name='cloud-done-outline'] {
            color: #04ae04;
          }
          &[name='cloud-offline-outline'] {
            color: #ed143d;
          }
        }
      }
    `, "",{"version":3,"sources":["webpack://./src/app/shared/wm-core/projects/wm-core/src/shared/ugc-synchronized-badge/ugc-synchronized-badge.component.ts"],"names":[],"mappings":";MACM;QACE;UACE,WAAW;UACX,YAAY;UACZ,kBAAkB;UAClB,YAAY;UACZ,sBAAsB;UACtB;YACE,cAAc;UAChB;UACA;YACE,cAAc;UAChB;QACF;MACF","sourcesContent":["\n      wm-ugc-synchronized-badge {\n        ion-icon {\n          width: 22px;\n          height: 22px;\n          border-radius: 8px;\n          padding: 3px;\n          background-color: #fff;\n          &[name='cloud-done-outline'] {\n            color: #04ae04;\n          }\n          &[name='cloud-offline-outline'] {\n            color: #ed143d;\n          }\n        }\n      }\n    "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
